export const stickyHeaderElement = document.querySelector('.navbar-area');